import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Viewmeatingpage() {
  const [meetings, setMeetings] = useState([]);
  const [error, setError] = useState(null);
  const [selectedId, setSelectedId] = useState(null); // for modal
  const [showModal, setShowModal] = useState(false);  // modal visibility

  const api = process.env.REACT_APP_API;
  const UNIFORM_COST = 549;
  const MEETING_COST = 250;
  const navi =useNavigate()
useEffect(() => {
    const role = localStorage.getItem("userRole");
    if (role !== "supperadmin") {
      // alert("Access denied. You do not have permission to view this page.");
      navi("/"); // redirect to home or login page
    }
  }, [navi]);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${api}/meeting/viewmeeting`);
      setMeetings(response.data);
    } catch (err) {
      console.error('Error fetching meetings:', err);
      setError('Failed to load meeting data');
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getSizes = (sizes) => {
    try {
      if (Array.isArray(sizes)) return sizes.join(', ');
      const parsed = JSON.parse(sizes);
      return Array.isArray(parsed) ? parsed.join(', ') : parsed || '—';
    } catch {
      return sizes || '—';
    }
  };

  const handleAction = async (id) => {
    try {
      await axios.get(`${api}/meeting/meetingin/${id}`);
      fetchData();
    } catch (err) {
      console.log(err);
    }
  };

  const handleConfirmClick = (id) => {
    setSelectedId(id);
    setShowModal(true);
  };

  const handleConfirmYes = () => {
    handleAction(selectedId);
    setShowModal(false);
  };

  const handleConfirmNo = () => {
    setSelectedId(null);
    setShowModal(false);
  };
  const totalUniformQty = meetings.reduce((sum, m) => sum + (m.uniformQty || 0), 0);
const totalAmount = meetings.reduce((sum, m) => sum + ((m.uniformQty || 0) * UNIFORM_COST + MEETING_COST), 0);


  return (
    <div style={{ padding: '30px', fontFamily: 'Segoe UI, sans-serif', backgroundColor: '#f9f9f9' }}>
      <h2 style={{ marginBottom: '20px' }}>🗓️ Meeting List</h2>
      <div style={{ marginBottom: '20px', fontWeight: 500 }}>
  <h3>Total Uniforms: <span style={{color:"green"}}>{totalUniformQty}</span> </h3>
  <h3>Total Amount: ₹<span style={{color:"green"}}>{totalAmount}</span></h3>
</div>


      {error && <p style={{ color: 'red' }}>{error}</p>}

      {meetings.length === 0 && !error ? (
        <p>Loading meetings...</p>
      ) : (
        <div style={{ overflowX: 'auto', border: '1px solid #ddd', borderRadius: '6px', backgroundColor: '#fff' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '1000px' }}>
            <thead>
              <tr style={{ backgroundColor: '#004080', color: '#fff' }}>
                {['#', 'Name', 'Username', 'merchantOrderId', 'Phone', 'Aadhaar No', 'Designation', 'Amount', 'Uniform Qty', 'Sizes', 'Status', 'Action'].map((title, i) => (
                  <th key={i} style={thStyle}>{title}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {meetings.map((meeting, index) => (
                <tr key={meeting.id} style={index % 2 === 0 ? rowEvenStyle : rowOddStyle}>
                  <td style={tdStyle}>{index + 1}</td>
                  <td style={tdStyle}>{meeting.full_name}</td>
                  <td style={tdStyle}>{meeting.username}</td>
                  <td style={tdStyle}>{meeting.merchantOrderId}</td>
                  <td style={tdStyle}>{meeting.phone}</td>
                  <td style={tdStyle}>{meeting.aadhaar_no}</td>
                  <td style={tdStyle}>{meeting.designation || '—'}</td>
                  <td style={tdStyle}>{meeting.uniformQty * UNIFORM_COST + MEETING_COST}</td>
                  <td style={tdStyle}>{meeting.uniformQty}</td>
                  <td style={tdStyle}>{getSizes(meeting.uniformSizes)}</td>
                  <td style={tdStyle}>
                    {meeting.presented === 'yes' ? '✅ In' : '❌ Not in'}
                  </td>
                  <td style={tdStyle}>
                    <button
                      style={{
                        ...buttonStyle,
                        backgroundColor: meeting.presented === 'yes' ? '#6c757d' : '#007bff',
                        cursor: meeting.presented === 'yes' ? 'not-allowed' : 'pointer'
                      }}
                      disabled={meeting.presented === 'yes'}
                      onClick={() => handleConfirmClick(meeting.merchantOrderId)}
                    >
                      in
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showModal && (
        <div style={modalOverlayStyle}>
          <div style={modalStyle}>
            <p>Are you sure you want to mark this as <b>"in"</b>?</p>
            <div style={{ marginTop: '15px' }}>
              <button style={modalButtonStyle} onClick={handleConfirmYes}>Yes</button>
              <button style={{ ...modalButtonStyle, marginLeft: '10px' }} onClick={handleConfirmNo}>No</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// Inline styles
const thStyle = {
  borderBottom: '2px solid #ccc',
  padding: '12px 10px',
  textAlign: 'left',
  fontSize: '14px',
  fontWeight: '600',
};

const tdStyle = {
  padding: '10px',
  borderBottom: '1px solid #eee',
  fontSize: '14px',
};

const rowEvenStyle = {
  backgroundColor: '#ffffff',
};

const rowOddStyle = {
  backgroundColor: '#f9f9f9',
};

const buttonStyle = {
  color: '#fff',
  border: 'none',
  padding: '6px 12px',
  borderRadius: '4px',
  fontSize: '13px',
};

// 🔥 Modern Modal Styles
const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0, 0, 0, 0.4)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
  backdropFilter: 'blur(2px)',
};

const modalStyle = {
  backgroundColor: '#ffffff',
  padding: '30px 25px',
  borderRadius: '12px',
  width: '340px',
  textAlign: 'center',
  boxShadow: '0 15px 30px rgba(0, 0, 0, 0.2)',
  animation: 'fadeIn 0.3s ease-in-out',
};

const modalButtonStyle = {
  padding: '10px 20px',
  borderRadius: '8px',
  border: 'none',
  backgroundColor: '#007bff',
  color: '#ffffff',
  fontSize: '15px',
  fontWeight: '500',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
};

const modalButtonHoverStyle = {
  backgroundColor: '#0056b3',
  transform: 'scale(1.05)',
};


export default Viewmeatingpage;
